import {useInjex} from '@injex/react-plugin';
import {SessionManager} from '../managers/sessionManager.mdl';

export default function useSessionManager(): SessionManager {
    const [inject] = useInjex();
    return inject<SessionManager>('sessionManager');
}